import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION2: PdfComponent = {
  type: 'section',
  id: 's1s2',
  title: '2. Data Controllers',
  content: [
    {
      type: 'bulletList',
      id: 's2bs2ullets',
      bulletType: 'number',
      content: [
        {
          copy: {
            type: 'altText',
            id: '2joint',
            content: [
              'For the purposes of this Agreement, Ideal4Finance and the Subscriber agree that they shall act as ',
              'Joint Controllers',
              ' under Data Privacy Laws in respect of the Processing of Personal Information carried out in connection with this Agreement.',
            ],
            boldFirst: false,
          },
        },
        {
          copy: 'Each party agrees that, in respect of the Personal Information:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: {
                  type: 'altText',
                  id: '2dc',
                  content: [
                    'it shall be a ',
                    'Data Controller',
                    ' under Data Privacy Laws;',
                  ],
                  boldFirst: false,
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: '2jc',
                  content: [
                    'it shall be a ',
                    'Joint Controller',
                    ' with the other party, by operation of Data Privacy Laws;',
                  ],
                  boldFirst: false,
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: '2jsl',
                  content: [
                    'subject to any written agreement to the contrary, both parties shall be ',
                    'jointly and severally liable',
                    ' for any breaches of Data Privacy Laws in respect of the Personal Information; and',
                  ],
                  boldFirst: false,
                },
              },
              {
                copy: 'this Agreement sets out the mutual responsibilities and obligations of the parties as Data Controllers and Joint Controllers under applicable Data Privacy Laws.',
              },
            ],
          },
        },
      ],
      prefix: '2',
    },
  ],
};
